import { createAction } from '@housinganywhere/safe-redux';
import { Thunk } from 'ha/myredux/types';
import { reportError } from 'ha/helpers/bugsnag/reportError';
import {
  AdvertiserOverallRatingResponse,
  GetAdvertiserOverallRatingQuery,
} from '@ha/api/v2/types/surveyReviews/AdvertiserOverallRating';

import { Actions } from '../constants';

export const actions = {
  start: () => createAction(Actions.LOAD_TENANT_REVIEWS_OVERALL_START),
  done: (payload: { overallRating: AdvertiserOverallRatingResponse | null }) =>
    createAction(Actions.LOAD_TENANT_REVIEWS_OVERALL_DONE, payload),
  fail: () => createAction(Actions.LOAD_TENANT_REVIEWS_OVERALL_FAIL),
};

const loadTenantReviewsOverall =
  (landlordId: number): Thunk =>
  (dispatch, _, { apiV2 }) => {
    dispatch(actions.start());

    const overallRatingQuery: GetAdvertiserOverallRatingQuery = {
      landlordId,
    };
    return apiV2
      .getReviewAdvertiserOverallRating(overallRatingQuery)
      .then(({ data: overallRating }) => {
        dispatch(actions.done({ overallRating }));
      })
      .catch(error => {
        dispatch(actions.fail());
        reportError('apiV2 tenant reviews overall request failed', {
          metaData: { error },
        });
      });
  };

export { loadTenantReviewsOverall };
